
import React, { useEffect, useState } from "react";
import Job, { techHasCalled } from "../models/Job";
import FlexRow from "../../../../components/base/FlexRow";
import Icon from "../../../../components/base/Icon";
import PerCallDuplicateBadge from "./PerCallDuplicateBadge";
import Timer from "../../../../components/timer/Timer";
import Clock from "../../../../components/timer/Clock";
import { Link, useNavigate } from "react-router-dom";
import { createJob, deleteJobOpen, getUser, hasRole, isDarkMode, isDemo, openArchiveJob, openCopyJob, openEditJobDetails, openJobQuickView, opennotCalledActions, toAppointmentHours, toPrettyDate, useChatList, useGlobal, useHub, usePreferences, useScreen, useSocket, useStatusesForJob, useHasMaskedJobCalls } from "../../../../core/Global";
import { API_ROUTES } from "../../../../core/Constants";
import JobStatus from "../../base/models/JobStatus";
import Avatar from "../../../../components/base/Avatar";
import DropdownMenu, { MenuItem } from "../../../../components/menu/DropdownMenu";
import { convertTo12HourFormat, copyToClipboard } from "../../../../core/Helper";
import Time from "../../../../components/timer/Time";
import { TimeFormats, UserTypes } from "../../../../core/Enums";
import JobAddTag from "./JobAddTag";
import ToolTip from "../../../../components/base/ToolTip";
import JobColorPicker from "./JobColorPicker";
import { canPaintJob, jobColorOf, jobColorVars } from "./JobColor";
import "./JobColor.css";
import moment from "moment";
import { COMPACT_ACTIONS_WIDTH, GridFieldId, gridFieldOn, LIST_COLUMN_GAP, ListColumnId, useListLayout } from "../utils/jobsBoardSettings";

interface IProps {
    job: Job
    onQuickView?: (job: Job) => void
    onUpdateAddress?: (job: Job) => void
    onUpdateTech?: (job: Job) => void
    onUpdateAppointment?: (job: Job) => void
    onUpdateStatusAppointment?: (job: Job) => void
    onUpdateStatus?: (job: Job) => void
    onUpdateStatusNote?: (job: Job, st: JobStatus) => void
    onSendJob?: (job: Job) => void
    onManageTechResponse?: (job: Job, s: number) => void
    onViewNotes?: (job: Job) => void
    onOpenAttachments?: (job: Job) => void
    onViewTasks?: (job: Job) => void
    onEdit?: (job: Job) => void
    onCloseJob?: (job: Job, callback: () => void) => void
    onInProgressError?: (err: string) => void
    onReopenFromClosed?: (job: Job, st: JobStatus) => void
    selectable?: boolean
    selected?: boolean
    selectionMode?: boolean
    onToggleSelect?: () => void
    /** "card" = the board's grid view; default is the list row. */
    layout?: "row" | "card"
    /** Write the status's name by its dot, "Pending (2h)": the board is grouped by something
     *  other than status, so no group header says it. */
    showStatusName?: boolean
}
const JobDataFullCard = (props: IProps) => {

    const hub = useHub();
    // Whether there is a proxy number to show at all.
    const maskedAllowed = useHasMaskedJobCalls()
    const user = getUser();
    const chats = useChatList();
    const statuses = useStatusesForJob()
    const screen = useScreen()
    const navigate = useNavigate();

    const layout = useListLayout(screen.width)


    const [compact, compactSet] = useState<boolean>(false)

    const [techAcceptedTotalSeconds, techAcceptedTotalSecondsSet] = useState<number>(0)

    const [statusUpdating, statusUpdatingSet] = useState<boolean>(false);

    const [jobSentTime, jobSentTimeSet] = useState<number>(0);
    const [jobSentColor, jobSentColorSet] = useState<string>("success");



    useEffect(() => {
        if (props.job) {
            var HasAttachments = false;
            var hasTasks = false;

            if (props.job.attachmentsCount && props.job.attachmentsCount > 0 && props.job.usersSeenAttachments && user?.id && props.job.usersSeenAttachments.indexOf(user.id) < 0) HasAttachments = true;
            if (props.job.tasksCount && props.job.tasksCount > 0 && props.job.usersSeenTasks && user?.id && props.job.usersSeenTasks.indexOf(user.id) < 0) hasTasks = true;


            props.job.flags?.forEach(f => {
                window.createBootstrapTooltip(`job-flags-${props.job.id}-${f.id}`);
            });

            window.createBootstrapTooltip(`job-tags-${props.job.id}`)

        }
    }, [props.job])


    useEffect(() => {
        if (props.job.techAcceptedAt) {
            const secondsPassed = moment().diff(moment.utc(props.job.techAcceptedAt), 'seconds');
            techAcceptedTotalSecondsSet(secondsPassed);

            const callIntv = setInterval(() => {
                techAcceptedTotalSecondsSet(t => t + 1);
            }, 1000);

            return () => {
                clearInterval(callIntv);
            }
        }
    }, [props.job.techAcceptedAt])




    const [chatOpened, chatOpenedSet] = useState<boolean>(false);
    useEffect(() => {
        chatOpenedSet(false);
    }, [chats]);

    const HasUnreadChat = () => {
        if (chatOpened) return false;
        var res = false;
        chats?.forEach(c => {
            if (c.tech?.id && props.job.techId && c.tech.id == props.job.techId && c.unreadCount && c.unreadCount > 0) {
                res = true;
                return;
            }
        })
        return res;
    }

    const HasChat = () => {
        var res = false;
        chats?.forEach(c => {
            if (c.tech?.id && props.job.techId && c.tech.id == props.job.techId) {
                res = true;
                return;
            }
        })
        return res;
    }

    const jobColor = jobColorOf(props.job, user?.isTech)
    const canPaint = canPaintJob(props.job, user?.isTech, hasRole("EditArchivedJobs"))

    // Status dot + time in status; non-techs click it for the status menu.
    const statusPicker = (
        <FlexRow>
            {
                user?.isTech ?
                    <Icon icon="circle" type="solid" color={props.job.jobStatus?.color} size={12} />
                    :
                    <a href="#" title="Job Status"
                        data-kt-menu-trigger="click" data-kt-menu-placement="bottom-start"
                        onClick={e => {
                            e.preventDefault();
                            window.dataTableMenu();
                        }}>
                        {
                            statusUpdating ?
                                <Icon icon="circle-notch" type="solid" spin color={props.job.jobStatus?.color} size={12} />
                                :
                                <Icon icon="circle" type="solid" color={props.job.jobStatus?.color} size={12} />
                        }

                    </a>
            }

            {
                // Compact rows have no room for the status name beside the job id; the dot's
                // colour and the time stay, the name is in the tooltip.
                props.showStatusName && layout.settings.density != "compact" ?
                    <span className="fs-8 ms-1 limited-text" title={props.job.jobStatus?.name}
                        style={{ maxWidth: layout.idWidth - 24 }}>
                        {props.job.jobStatus?.name}
                        {" ("}
                        <Timer key={`job-timer-${props.job.id}`} baseDate={props.job.lastStatusUpdatedAt} short />
                        {")"}
                    </span>
                    :
                    <span className={`fs-8 ms-1`} style={{ width: 45 }} title={props.job.jobStatus?.name}>
                        <Timer key={`job-timer-${props.job.id}`} baseDate={props.job.lastStatusUpdatedAt} short />
                    </span>
            }
            <div className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-150px py-1" data-kt-menu="true">
                <div className="menu-item">
                    <a href="#" className="menu-link px-3"

                        onClick={e => {
                            e.preventDefault();
                            statusUpdatingSet(true);
                            hub.Post(API_ROUTES.Jobs + "refreshstatus", {
                                id: props.job?.id
                            }, res => {
                                statusUpdatingSet(false);
                            });
                        }}>
                        <Icon icon="redo" color={props.job.jobStatus?.color} className="me-2" />
                        Refresh Status
                    </a>
                </div>
                {
                    statuses?.map((st, k) =>
                        <React.Fragment key={`status-${st.id}`}>
                            {
                                st.id == props.job.jobStatusId ? <></>
                                    :
                                    <div className="menu-item">
                                        <a href="#" className="menu-link px-3"

                                            onClick={e => {
                                                e.preventDefault();

                                                if (props.job.isClosed) {
                                                    if (props.onReopenFromClosed) props.onReopenFromClosed(props.job, st)
                                                }
                                                else if (st.isClosed) {
                                                    statusUpdatingSet(true)
                                                    if (props.onCloseJob) props.onCloseJob(props.job, () => statusUpdatingSet(false))
                                                }
                                                else if (st.isAppointment && window.isNullOrEmpty(props.job.appointmentDate)) {
                                                    if (props.onUpdateStatusAppointment) props.onUpdateStatusAppointment(props.job);
                                                }
                                                // A cancellation always goes through the note dialog, which is where the
                                                // cancel reason is picked.
                                                else if (st.noteRequired || st.isCanceled) {
                                                    if (props.onUpdateStatusNote) props.onUpdateStatusNote(props.job, st);
                                                }
                                                else {
                                                    statusUpdatingSet(true);
                                                    hub.Post(API_ROUTES.Jobs + "jobstatus", {
                                                        id: props.job?.id,
                                                        status: st.id
                                                    }, res => {
                                                        statusUpdatingSet(false);
                                                    });

                                                }

                                            }}>
                                            <Icon icon="circle" type="solid" color={st.color} className="me-2" />
                                            {st.name}
                                        </a>
                                    </div>
                            }
                        </React.Fragment>
                    )
                }
            </div>
        </FlexRow>
    )

    // What the technician has done with the job: send timer, accepted, called / not called.
    const techStatus = (
        <>
            {
                props.job.sentToTech && !props.job.techAccepted && !props.job.isClosed && !props.job.isCanceled &&
                <div>
                    <a href="#" title="Click to manage the technician respond!"
                        onClick={e => {
                            e.preventDefault();
                            if (user?.isTech) return;
                            if (props.onManageTechResponse) props.onManageTechResponse(props.job, jobSentTime);
                        }}>
                        <FlexRow className={"text-" + jobSentColor}>
                            <Icon icon="timer" className="me-1" />
                            <Timer baseDate={props.job.sentToTechAt}
                                onTick={t => {
                                    jobSentColorSet(t < 60 ? "success" : t < 120 ? "warning" : "danger");
                                    jobSentTimeSet(t);
                                }} />
                        </FlexRow>
                    </a>
                </div>
            }

            {
                props.job.tech && props.job.techAccepted &&
                <>
                    {
                        techHasCalled(props.job) ?
                            <FlexRow title="Technician has contacted the customer!">
                                <Icon icon="phone-circle" className="text-success me-1" type="solid" />
                                <span className="text-success fs-9" style={{ marginTop: 1 }}>Called</span>
                            </FlexRow>
                            : props.job.creatorUserId == props.job.techId ?
                                <FlexRow>
                                    <Icon icon="user-helmet-safety" className="text-info me-1" type="solid" />
                                    <span className="text-info fs-9" style={{ marginTop: 2 }}>Added By Tech</span>
                                </FlexRow>
                                : (props.job.ignoreNotCalledAlert || !maskedAllowed) ?
                                    <FlexRow>
                                        <Icon icon="phone-circle" className="text-info me-1" type="solid" />
                                        <span className="text-info fs-9" style={{ marginTop: 1 }}>{props.job.ignoreNotCalledAlert ? props.job.ignoreNotCalledText : "Direct Given!"}</span>
                                    </FlexRow>
                                    : techAcceptedTotalSeconds > 300 ?
                                        <FlexRow title="Technician call delayed!" className="blinking-text" onClick={() => {
                                            if (user?.userType == UserTypes.Technician) return;
                                            opennotCalledActions(props.job)
                                        }}>
                                            <Icon icon="phone-slash" className="text-danger me-1" type="solid" />
                                            <span className="text-danger fs-8 me-2" style={{ marginTop: 1 }}>
                                                Not Called!
                                            </span>
                                            <span className="text-danger fs-9" style={{ marginTop: 1.5 }}>
                                                <Time totalSeconds={techAcceptedTotalSeconds} />
                                            </span>
                                        </FlexRow>
                                        : techAcceptedTotalSeconds > 100 ?
                                            <FlexRow title="Technician call delayed!" onClick={() => {
                                                if (user?.userType == UserTypes.Technician) return;
                                                opennotCalledActions(props.job)
                                            }}>
                                                <Icon icon="phone-slash" className="text-warning me-1" type="solid" />
                                                <span className="text-warning fs-8 me-2" style={{ marginTop: 1 }}>
                                                    Not Called!
                                                </span>
                                                <span className="text-warning fs-9" style={{ marginTop: 1.5 }}>
                                                    <Time totalSeconds={techAcceptedTotalSeconds} />
                                                </span>
                                            </FlexRow>
                                            :
                                            <FlexRow title="Technician has accepted the job!">
                                                <Icon icon="check-circle" className="text-success me-1" type="solid" />
                                                <span className="text-success fs-9" style={{ marginTop: 1 }}>Accepted</span>
                                            </FlexRow>

                    }

                </>
            }
        </>
    )

    // Paid badge, flags and tags, each removable.
    const tagBadges = (
        <>
            {
                (props.job.payment?.paid || props.job.paid) &&
                <span className="badge badge-success me-1">
                    <Icon icon="check" size={10} type="solid" className="me-1" />
                    Paid by Rinvox
                </span>
            }

            <PerCallDuplicateBadge job={props.job} />
            {
                props.job.flags?.map(flag =>
                    <span key={`job-${props.job.id}-flag-${flag.id}`} className="badge badge-danger me-1"
                        style={{ backgroundColor: flag.color }}>
                        <Icon icon="flag" size={10} type="solid" className="me-1" />
                        {flag.name}
                        {
                            (!props.job?.isArchived || hasRole("EditArchivedJobs")) &&
                            <a href="#" className="ps-2" title="Remove Tag"
                                onClick={e => {
                                    e.preventDefault();
                                    hub.Post(API_ROUTES.Jobs + "removeflag", {
                                        jobId: props.job.id,
                                        flagId: flag.id
                                    }, res => { })
                                }}>
                                <Icon icon="times" className="text-white fs-8" />
                            </a>
                        }
                    </span>
                )
            }
            {
                props.job.tags?.map(tag =>
                    <span key={`job-${props.job.id}-flag-${tag.id}`}
                        className="badge badge-secondary me-1"
                        style={{
                            backgroundColor: isDarkMode() ? undefined : "rgb(227 227 231)"
                        }}>
                        <Icon icon="tag" size={10} type="solid" className="me-1" />
                        {tag.name}
                        {
                            (!props.job.isArchived || hasRole("EditArchivedJobs")) &&
                            <a href="#" className="ps-2" title="Remove Tag"
                                onClick={e => {
                                    e.preventDefault();
                                    hub.Post(API_ROUTES.Jobs + "removetag", {
                                        jobId: props.job.id,
                                        tagId: tag.id
                                    }, res => { })
                                }}>
                                <Icon icon="times" className="text-muted fs-8" />
                            </a>
                        }
                    </span>
                )
            }
        </>
    )

    // The job's more-actions menu (the ⋮ at the end of the row).
    const moreMenuItems: MenuItem[] = [
        {
            title: "Archive Job",
            icon: "archive",
            visible: props.job.isClosed || props.job.isCanceled,
            action() {
                openArchiveJob(props.job)
            },
        },
        {
            title: "View Job Details",
            icon: "eye",
            to: "/crm/jobs/overview/" + props.job.id
        },
        {
            title: "Estimates",
            icon: "file-invoice-dollar",
            action() {
                navigate("/crm/jobs/estimates/" + props.job.id)
            }
        },
        {
            title: "Invoices",
            icon: "file-invoice-dollar",
            action() {
                navigate("/crm/jobs/invoices/" + props.job.id)
            }
        },
        {
            title: "Attachments",
            icon: "paperclip-vertical",
            visible: !props.job.isClosed && !props.job.isCanceled,
            action() {
                if (props.onOpenAttachments) props.onOpenAttachments(props.job);
            }
        },
        {
            title: "Tasks",
            icon: "alarm-clock",
            visible: !props.job.isClosed && !props.job.isCanceled,
            action() {
                if (props.onViewTasks) props.onViewTasks(props.job);
            }
        },
        {
            title: "Copy Job",
            icon: "copy",
            async click(e) {
                e.preventDefault();
                var res = await hub.GetAsync(API_ROUTES.Jobs + "copyjob/" + props.job.id + "/?directNumber=True")
                var copy = await copyToClipboard(res.data, "Job has been copied to the clipboard!");
                if (!copy) openCopyJob(props.job);
            },
        },
        {
            title: "Copy with Extension",
            visible: maskedAllowed,
            icon: "phone-office",
            async click(e) {
                e.preventDefault();
                var res = await hub.GetAsync(API_ROUTES.Jobs + "copyjob/" + props.job.id + "/?directNumber=False")
                var copy = await copyToClipboard(res.data, "Job has been copied to the clipboard!");
                if (!copy) openCopyJob(props.job);
            }
        },
        {
            title: "Duplicate",
            icon: "layer-plus",
            action() {
                createJob(props.job.id);
            }
        },
        {
            title: "Delete Job",
            icon: "minus-circle",
            danger: true,
            visible: hasRole("DeleteJob"),
            action() {
                deleteJobOpen(props.job);
            }
        }
    ]

    // Send / notes / chat / calls / open + the job's more-actions menu.
    // The row's actions: one toolbar of equal round-cornered buttons, an evenly spaced group with
    // the ⋮ menu set off at the end. A dot on a button = something there (blue) or something
    // new (red). Styles: JobsDashboard.css (.jobs-row-actions).
    const unreadCalls = (props.job.jobCalls ?? []).some(f => f.isCompleted && (f.listeners?.length ?? 0) < 1)
    const actionDot = (isNew: boolean, has: boolean) =>
        isNew ? <span className="jobs-act-dot is-new" />
            : has ? <span className="jobs-act-dot" />
                : <></>

    const actionIcons = (
        <div className="jobs-row-actions">

            {
                !props.job.isClosed && !props.job.isCanceled &&
                <a href="#" className={`jobs-act${props.job.sentToTech ? " is-sent" : ""}`}
                    title={props.job.sentToTech ? "Resend Job" : "Send Job"}
                    onClick={e => {
                        e.preventDefault();
                        if (props.onSendJob) props.onSendJob(props.job);
                    }}>
                    <Icon icon="share" type={props.job.sentToTech ? "solid" : "regular"} size={14} />
                </a>
            }

            <a href="#" className="jobs-act" title="Notes"
                onClick={e => {
                    e.preventDefault();
                    if (props.onViewNotes) props.onViewNotes(props.job);
                }}>
                <Icon icon="note" type="regular" size={14} />
                {actionDot(!!props.job.unseenNotes, (props.job.notesCount ?? 0) > 0)}
            </a>

            <a href="#" className={`jobs-act${props.job.techId ? "" : " is-disabled"}`}
                title={props.job.techId ? "Job Chat" : "Job Chat (assign a technician first)"}
                onClick={e => {
                    e.preventDefault();
                    if (props.job.techId) openJobQuickView(props.job.id, "4")
                }}>
                <Icon icon="comment-lines" type="regular" size={14} />
                {actionDot(HasUnreadChat(), HasChat())}
            </a>

            <a href="#" className="jobs-act" title="Job Calls"
                onClick={e => {
                    e.preventDefault();
                    openJobQuickView(props.job.id, "5")
                }}>
                <Icon icon="phone" type="regular" size={14} />
                {actionDot(unreadCalls, (props.job.jobCalls?.length ?? 0) > 0)}
            </a>

            <a href={"/crm/jobs/overview/" + props.job.id} target="_blank" className="jobs-act" title="Open Job Details in a new tab">
                <Icon icon="arrow-up-right-from-square" type="regular" size={13} />
            </a>

            <span className="jobs-act-sep" />

            <div>
                <a href="#" className="jobs-act jobs-act-more" title="More"
                    data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end"
                    onClick={e => {
                        e.preventDefault();
                        window.dataTableMenu();
                    }}>
                    <Icon icon="ellipsis-vertical" type="regular" size={14} />
                </a>
                <DropdownMenu width={210} source={moreMenuItems} />
            </div>

        </div>
    )

    const isTechUser = user?.userType == UserTypes.Technician

    if (props.layout == "card") {
        const sendable = !props.job.isClosed && !props.job.isCanceled
        const hasUnread = !!props.job.unseenNotes || HasUnreadChat() || unreadCalls
        const hasTags = !!(props.job.payment?.paid || props.job.paid || props.job.isPerCallDuplicate || props.job.flags?.length || props.job.tags?.length)
        const gridOn = (id: GridFieldId) => gridFieldOn(layout.settings, id)

        // Everything the row shows as icons lives in the card's single ⋮ menu.
        const cardMenu: MenuItem[] = [
            {
                title: props.job.sentToTech ? "Resend Job" : "Send Job",
                icon: "share",
                iconColor: props.job.sentToTech ? "var(--bs-success)" : undefined,
                visible: sendable,
                action() { props.onSendJob?.(props.job) }
            },
            {
                title: "Notes",
                icon: "note",
                subtext: props.job.unseenNotes ? "New notes" : undefined,
                iconColor: props.job.unseenNotes ? "var(--bs-danger)" : undefined,
                action() { props.onViewNotes?.(props.job) }
            },
            {
                title: "Job Chat",
                icon: "comment-lines",
                subtext: HasUnreadChat() ? "Unread messages" : undefined,
                iconColor: HasUnreadChat() ? "var(--bs-danger)" : undefined,
                visible: !!props.job.techId,
                action() { openJobQuickView(props.job.id, "4") }
            },
            {
                title: "Job Calls",
                icon: "phone",
                subtext: unreadCalls ? "New calls" : undefined,
                iconColor: unreadCalls ? "var(--bs-danger)" : undefined,
                action() { openJobQuickView(props.job.id, "5") }
            },
            ...moreMenuItems
        ]

        // The card has one action: a click anywhere opens the job drawer. Only the checkbox,
        // the colour band and the ⋮ menu keep their own clicks: they carry .jobs-grid-card-nonav
        // and the card ignores clicks from inside them (and from portaled popups, which bubble
        // through React but sit outside the card's DOM). Not stopPropagation: the theme's ⋮
        // menu listens on the document, so a stopped click would never open it.
        const openFromCard = (e: React.MouseEvent<HTMLDivElement>) => {
            const target = e.target as HTMLElement
            if (!e.currentTarget.contains(target) || target.closest(".jobs-grid-card-nonav")) return
            props.onQuickView?.(props.job)
        }

        return (
            <div className={`jobs-board-row jobs-grid-card${props.selectionMode ? " selection-mode" : ""}${props.selected ? " selected" : ""}${jobColor ? " job-colored" : ""}`}
                style={{ ...jobColorVars(jobColor), borderColor: props.job.jobStatus?.color }}
                onClick={openFromCard}>

                <span className="jobs-grid-card-nonav">
                    {
                        canPaint
                            ? <JobColorPicker job={props.job} variant="spine" />
                            : jobColor
                                ? <span className="color-selector-spine is-static" style={{ backgroundColor: jobColor }} />
                                : <></>
                    }
                </span>

                {/* Status · job id · status time, the appointment time, and the ⋮ menu */}
                <FlexRow className="jobs-grid-card-head">
                    {
                        props.selectable &&
                        <div className="jobs-row-check jobs-grid-card-nonav me-2">
                            <input type="checkbox" className="jobs-check-input"
                                checked={!!props.selected}
                                onChange={() => props.onToggleSelect?.()} />
                        </div>
                    }
                    <span className="jobs-grid-card-status" title={props.job.jobStatus?.name}>
                        <Icon icon="circle" type="solid" color={props.job.jobStatus?.color} size={10} className="me-2" />
                        <span className="jobs-grid-card-id">#{props.job.jobId}</span>
                    </span>
                    <span className="jobs-grid-card-timer limited-text" title={props.job.jobStatus?.name}>
                        {props.showStatusName && <>{props.job.jobStatus?.name} · </>}
                        <Timer key={`job-timer-${props.job.id}`} baseDate={props.job.lastStatusUpdatedAt} short />
                    </span>
                    {
                        !isTechUser &&
                        <div className="jobs-grid-card-nonav ms-auto">
                            <a href="#" className="jobs-grid-card-menu position-relative"
                                data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end"
                                onClick={e => {
                                    e.preventDefault();
                                    window.dataTableMenu();
                                }}>
                                <Icon icon="ellipsis-vertical" type="regular" size={14} />
                                {hasUnread && <span className="jobs-act-dot is-new" />}
                            </a>
                            <DropdownMenu width={200} source={cardMenu} />
                        </div>
                    }
                </FlexRow>

                {/* Customer and phone */}
                <FlexRow className="jobs-grid-card-line is-pair">
                    <span className="jobs-grid-card-name limited-text" title={props.job.fullName}>
                        <Icon icon="user" type="solid" size={10} className="me-2" />
                        {props.job.fullName || <span className="text-muted">No name</span>}
                    </span>
                    {
                        gridOn("phone") && props.job.phone &&
                        <span className="jobs-grid-card-phone text-nowrap">
                            <Icon icon="phone-rotary" type="solid" size={10} className="me-2" />
                            {isDemo() ? "(207) 333 4444" : props.job.phone.phoneFriendly}
                        </span>
                    }
                </FlexRow>

                {
                    gridOn("address") &&
                    <div className="jobs-grid-card-line limited-text" title={props.job.address?.title}>
                        <Icon icon="location-dot" type="solid" size={10} className="me-2" />
                        {
                            props.job.address?.title
                                ? (isDemo() ? "9977 S Semoran Blvd, Orlando, FL 9511-35777, USA" : props.job.address.title)
                                : <span className="text-muted">No address</span>
                        }
                    </div>
                }
                {
                    gridOn("tech") &&
                    <FlexRow className="jobs-grid-card-line" title={`Tech: ${props.job.tech?.fullName ?? "Undefined"}`}>
                        {
                            // The tech's face in place of the line icon; no tech keeps the icon.
                            props.job.tech
                                ? <Avatar avatarUrl={props.job.tech.avatarUrl} fullName={props.job.tech.fullName} width={16} className="jobs-grid-card-avatar" />
                                : <Icon icon="user-helmet-safety" type="solid" size={10} className="me-2" />
                        }
                        {
                            props.job.tech
                                ? <span className="limited-text">{isDemo() ? "Tech " + props.job.tech.fullName?.substring(0, 2).toUpperCase() : props.job.tech.fullName}</span>
                                : <span className="text-muted">No tech</span>
                        }
                        {props.job.tech && <span className="ms-2 jobs-grid-card-passive">{techStatus}</span>}
                    </FlexRow>
                }
                {
                    // Opt-in details (Customize Board > Grid).
                    (gridOn("jobType") || gridOn("source")) &&
                    <div className="jobs-grid-card-line limited-text">
                        <Icon icon="wrench" type="solid" size={10} className="me-2" />
                        {gridOn("jobType") && props.job.jobType}
                        {gridOn("jobType") && gridOn("source") && props.job.jobSourceId && " · "}
                        {gridOn("source") && props.job.jobSourceId && (isDemo() ? "Source " + props.job.jobSource?.substring(0, 1).toUpperCase() : props.job.jobSource)}
                    </div>
                }
                {
                    // The appointment's date and hours (the calendar's cards need only the hours).
                    gridOn("appointment") &&
                    <FlexRow className="jobs-grid-card-line" title="Appointment">
                        <Icon icon="calendar-check" type="solid" size={10} className="me-2" />
                        {
                            props.job.appointmentDate
                                ? <span className="limited-text">
                                    {toPrettyDate(props.job.appointmentFrom, props.job.timezoneOffset, true)}
                                    {toAppointmentHours(props.job) && <>, {toAppointmentHours(props.job)}</>}
                                </span>
                                : <span className="text-muted">No appointment</span>
                        }
                    </FlexRow>
                }
                {
                    gridOn("localTime") && props.job.stateId && props.job.timezone &&
                    <FlexRow className="jobs-grid-card-line" title={`Local time (${props.job.timezone})`}>
                        <Icon icon="earth-americas" type="solid" size={10} className="me-2" />
                        <Clock offset={props.job.timezoneOffset} />
                    </FlexRow>
                }
                {
                    gridOn("tags") && !isTechUser && hasTags &&
                    <FlexRow className="jobs-row-tags jobs-grid-card-passive mt-1">
                        {tagBadges}
                    </FlexRow>
                }
            </div>
        )
    }

    const listColumns = layout.columns
    // A column's content width: its share minus the gap that keeps it off the next column.
    const colWidth = (id: ListColumnId) => layout.width(id) - LIST_COLUMN_GAP
    const cellWidth = (id: ListColumnId): React.CSSProperties => {
        const w = colWidth(id)
        return { width: w, minWidth: w, maxWidth: w, overflow: "hidden" }
    }

    // The address as the Address column shows it: the full title, less the zip code and/or the
    // country when the person switched those parts off.
    const addressText = (() => {
        let t = props.job.address?.title ?? ""
        const a = props.job.address?.address
        if (!layout.part("address", "zip") && a?.postalCode)
            t = t.replace(new RegExp("\\s*" + a.postalCode.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")), "")
        if (!layout.part("address", "country")) {
            const names = [a?.countryName, a?.countryCode].filter(Boolean) as string[]
            for (const n of names) {
                const cut = t.replace(new RegExp(",\\s*" + n.replace(/[.*+?^${}()|[\]\\]/g, "\\$&") + "\\s*$", "i"), "")
                if (cut != t) { t = cut; break }
            }
        }
        return t.replace(/\s*,\s*$/, "").trim()
    })()

    // The list row's columns by id; the person's Customize Board settings pick which show and in
    // what order (see utils/jobsBoardSettings). The job id + status column always comes first.
    const rowCells: Record<ListColumnId, JSX.Element> = {
        contact: (
            <div key="contact" style={{
                width: colWidth("contact"),
                minWidth: colWidth("contact"),
                maxWidth: colWidth("contact"),
                overflow: "hidden"
            }}>
                <FlexRow>
                    <div className={`fs-7 limited-text`} title={`Name: ${props.job.fullName}`}
                        style={{
                            width: colWidth("contact") - 30
                        }}>
                        <a href="#" onClick={e => {
                            e.preventDefault();
                            if (props.onQuickView) props.onQuickView(props.job);
                        }}>
                            {props.job.fullName}
                        </a>
                    </div>

                </FlexRow>
                {
                    layout.part("contact", "phone") &&
                    <FlexRow className="text-gray-700 jobs-row-sub">
                        <Icon icon="phone-rotary" type="solid" className="me-1" size={9} />
                        {
                            isDemo() ?
                                <span className={`fs-8`}>
                                    {compact ? "+12073334444" : "(207) 333 4444"}
                                </span>
                                :
                                <span className={`fs-8`}>
                                    {props.job.phone?.phoneFriendly}
                                    {window.isNullOrEmpty(props.job.phone?.extension) ? "" : " , " + props.job.phone?.extension}
                                </span>
                        }

                    </FlexRow>
                }
                {
                    props.job.phoneContact && layout.part("contact", "secondaryPhone") &&
                    <FlexRow className="text-gray-700 jobs-row-sub">
                        <Icon icon="phone-rotary" type="solid" className="me-1" size={9} />
                        {
                            isDemo() ?
                                <span className={`fs-8`}>
                                    {compact ? "+12073334444" : "(207) 333 4444"}
                                </span>
                                :
                                <span className={`fs-8`}>
                                    {props.job.phoneContact?.phoneFriendly}
                                    {window.isNullOrEmpty(props.job.phoneContact?.extension) ? "" : " , " + props.job.phoneContact?.extension}
                                </span>
                        }

                    </FlexRow>
                }
                {
                    props.job.company && layout.part("contact", "company") &&
                    <FlexRow className="text-gray-700 jobs-row-sub">
                        <Icon icon="briefcase" type="solid" className="me-1" size={9} />
                        <span className={`fs-8 limited-text`} style={{ maxWidth: colWidth("contact") - 14 }}>
                            {props.job.company}
                        </span>
                    </FlexRow>
                }
                {
                    props.job.emailAddress && layout.part("contact", "email") &&
                    <FlexRow className="text-gray-700 jobs-row-sub" title={props.job.emailAddress}>
                        <Icon icon="envelope" type="solid" className="me-1" size={9} />
                        <a href={`mailto:${props.job.emailAddress}`} className="fs-8 limited-text text-gray-700"
                            style={{ maxWidth: colWidth("contact") - 14 }}>
                            {props.job.emailAddress}
                        </a>
                    </FlexRow>
                }
            </div>
        ),
        type: (
            <div key="type" style={{
                width: colWidth("type"),
                minWidth: colWidth("type"),
                maxWidth: colWidth("type"),
                overflow: "hidden"
            }}>
                <div className={`fs-7 limited-text`}
                    title={`Job Type: ${props.job.jobType}`}
                    style={{
                        width: colWidth("type") - 30
                    }}>
                    {props.job.jobType}
                </div>
                {
                    props.job.jobTypeGroup && layout.part("type", "group") &&
                    <FlexRow className="text-gray-700 jobs-row-sub" title={`Job Type Group: ${props.job.jobTypeGroup}`}>
                        <Icon icon="layer-group" type="solid" className="me-1" size={9} />
                        <span className="fs-8 limited-text" style={{ maxWidth: colWidth("type") - 14 }}>
                            {props.job.jobTypeGroup}
                        </span>
                    </FlexRow>
                }
                {
                    // Job details sit under the job type as a badge: capped to the column's width
                    // so it never widens it, the whole text in a tooltip, a click opens the job.
                    !window.isNullOrEmpty(props.job.jobDetails) && layout.part("type", "details") &&
                    <ToolTip className="jobs-row-details jobs-row-sub mt-1" placement="top" maxWidth={440}
                        content={
                            <div className="jobs-details-tip">
                                <div className="jobs-details-tip-title">
                                    <Icon icon="memo" type="solid" size={11} className="me-2" />
                                    Job Details
                                </div>
                                <div className="jobs-details-tip-body">{props.job.jobDetails}</div>
                            </div>
                        }>
                        <a href="#" className="badge jobs-row-details-badge"
                            style={{ maxWidth: colWidth("type") - 30 }}
                            onClick={e => {
                                e.preventDefault();
                                if (props.onQuickView) props.onQuickView(props.job);
                            }}>
                            <Icon icon="memo" type="solid" size={10} className="me-1" />
                            <span className="jobs-row-details-text">{props.job.jobDetails}</span>
                        </a>
                    </ToolTip>
                }

            </div>
        ),
        source: (
            <div key="source" style={{
                width: colWidth("source"),
                minWidth: colWidth("source"),
                maxWidth: colWidth("source"),
                overflow: "hidden"
            }}>
                {
                    props.job.jobSourceId ?
                        <>
                            <div className={`fs-7  limited-text`}
                                style={{
                                    width: colWidth("source") - 50
                                }}>
                                {isDemo() ? "Source " + props.job.jobSource?.substring(0, 1).toUpperCase() : props.job.jobSource}
                            </div>
                            {
                                layout.part("source", "sourceType") &&
                                <FlexRow className="text-gray-700 limited-text jobs-row-sub">
                                    <Icon icon="bullhorn" type="solid" className="me-1" size={9} />
                                    <span className={`fs-8`}>
                                        {props.job.jobSourceType}
                                    </span>
                                </FlexRow>
                            }
                        </>
                        :
                        <div className="fs-8 text-primary blinking-text cursor-pointer"
                            onClick={e => {
                                e.preventDefault()
                                openEditJobDetails(props.job)
                            }}>
                            [Assign Source]
                        </div>
                }
            </div>
        ),
        address: (
            <div key="address" style={{
                width: colWidth("address"),
                minWidth: colWidth("address"),
                maxWidth: colWidth("address"),
                paddingRight: 10
            }}>
                {
                    user?.userType == UserTypes.Technician ?
                        <div className={`fs-7 jobs-row-address`} title={props.job.address?.title}>
                            {addressText}
                        </div>
                        :
                        <div>
                            <a href="#" onClick={e => {
                                e.preventDefault();
                                if (props.onUpdateAddress) props.onUpdateAddress(props.job);
                            }}>
                                {
                                    props.job.address?.title ?
                                        <>
                                            {
                                                isDemo() ?
                                                    <div className={`fs-7`}>
                                                        9977 S Semoran Blvd, Orlando, FL 9511-35777, USA
                                                    </div>
                                                    :
                                                    <div className={`fs-7 jobs-row-address`} title={props.job.address.title}>
                                                        {addressText}
                                                    </div>
                                            }
                                        </>
                                        :
                                        <div className="text-muted fs-8">
                                            [Set]
                                        </div>
                                }

                            </a>
                        </div>
                }

            </div>
        ),
        metro: (
            <div key="metro" className="fs-7" style={{
                width: colWidth("metro"),
                minWidth: colWidth("metro"),
                maxWidth: colWidth("metro")
            }}>
                {
                    user?.userType == UserTypes.Technician ?
                        <div className="fs-7 limited-text"
                            style={{
                                width: colWidth("metro") - 20
                            }}>
                            {props.job.metroName}
                        </div>
                        :
                        <a href="#" onClick={e => {
                            e.preventDefault();
                            if (props.onUpdateTech) props.onUpdateTech(props.job);
                        }}>
                            {
                                props.job.metroId ?
                                    <div className="fs-7 limited-text"
                                        style={{
                                            width: colWidth("metro") - 20
                                        }}>
                                        {props.job.metroName}
                                    </div>
                                    :
                                    <div className="text-muted fs-8">
                                        [Assign]
                                    </div>
                            }
                        </a>
                }

            </div>
        ),
        tech: (
            <div key="tech" style={{
                width: colWidth("tech"),
                minWidth: colWidth("tech"),
                maxWidth: colWidth("tech")
            }}>

                <FlexRow title={`Tech: ${props.job.tech?.fullName ?? "Undefined"}`}>

                    {
                        user?.userType == UserTypes.Technician ?
                            <div className={`limited-text fs-7`}
                                style={{
                                    width: colWidth("tech") - 20,
                                }}>
                                {props.job.tech?.fullName}
                            </div>
                            :
                            <a href="#" className="d-flex align-items-center" onClick={e => {
                                e.preventDefault();
                                if (props.job.sentToTech && !props.job.techAccepted) {
                                    if (props.onManageTechResponse) props.onManageTechResponse(props.job, jobSentTime);
                                }
                                else if (props.onUpdateTech) props.onUpdateTech(props.job);
                            }}>
                                {/* Fixed 24px lane so the status line below can start exactly where the name does. */}
                                <div style={{ width: 24, minWidth: 24, flexShrink: 0 }}>
                                    <Avatar avatarUrl={props.job.tech?.avatarUrl} fullName={props.job.tech?.fullName}
                                        width={20} />
                                </div>
                                {
                                    props.job.tech ?
                                        <span className={`limited-text fs-7`}
                                            style={{
                                                // Leave room for the avatar (~28px) so a long name doesn't spill into the next column.
                                                width: colWidth("tech") - 50,
                                            }}>
                                            {isDemo() ? "Tech " + props.job.tech.fullName?.substring(0, 2).toUpperCase() : props.job.tech.fullName}
                                        </span>
                                        :
                                        <div className="text-muted fs-8">
                                            [Assign Tech]
                                        </div>
                                }
                            </a>
                    }


                </FlexRow>

                {/* Indented by the avatar's 24px lane so the status sits right under the tech's name. */}
                <div className="jobs-row-sub" style={{ paddingLeft: user?.userType == UserTypes.Technician ? 0 : 24 }}>
                {techStatus}
                </div>


            </div>
        ),
        appointment: (
            <div key="appointment" style={{
                width: colWidth("appointment"),
                minWidth: colWidth("appointment"),
                maxWidth: colWidth("appointment")
            }}>
                {
                    user?.userType == UserTypes.Technician ?
                        <div>
                            {
                                props.job.appointmentDate ?
                                    <>
                                        <div className="fs-7">
                                            {toPrettyDate(props.job.appointmentFrom, props.job.timezoneOffset, true)}
                                        </div>
                                        <FlexRow className="text-gray-700 fs-8 jobs-row-apt-hours">
                                            <Icon icon="clock" type="solid" className="fs-8 me-1" size={9} />
                                            {toAppointmentHours(props.job)}
                                        </FlexRow>
                                    </>
                                    :
                                    <div className="text-muted fs-8">
                                        -
                                    </div>
                            }
                        </div>
                        :
                        <div>
                            <a href="#" onClick={e => {
                                e.preventDefault();
                                if (props.onUpdateAppointment) props.onUpdateAppointment(props.job);
                            }}>
                                {
                                    props.job.appointmentDate ?
                                        <>
                                            <div className="fs-7">
                                                {toPrettyDate(props.job.appointmentFrom, props.job.timezoneOffset, true)}
                                            </div>
                                            <FlexRow className="text-gray-700 fs-8 jobs-row-apt-hours">
                                                <Icon icon="clock" type="solid" className="fs-8 me-1" size={9} />
                                                {toAppointmentHours(props.job)}
                                            </FlexRow>
                                        </>
                                        :
                                        <div className="text-muted fs-8">
                                            [Assign Apt]
                                        </div>
                                }
                            </a>
                        </div>
                }


                {
                    layout.part("appointment", "localTime") && props.job.stateId && props.job.timezone &&
                    <FlexRow className="text-gray-700 fs-8 jobs-row-sub" title={`Local time (${props.job.timezone})`}>
                        <Icon icon="earth-americas" type="solid" className="me-1" size={9} />
                        <Clock offset={props.job.timezoneOffset} />
                    </FlexRow>
                }
            </div>
        ),
        localTime: (
            <div key="localTime" className="fs-7" style={{
                width: colWidth("localTime"),
                minWidth: colWidth("localTime"),
                maxWidth: colWidth("localTime")
            }}>
                {
                    props.job.stateId && props.job.timezone ?
                        <>
                            <div title={props.job.timezone}>
                                <Icon icon="clock" className="me-1" size={11} />
                                <Clock offset={props.job.timezoneOffset} />
                            </div>
                        </>
                        :
                        <>
                            <Icon icon="clock" className="me-1" size={11} />
                            <span>-</span>
                        </>
                }
            </div>
        ),
        modified: (
            <div key="modified" style={cellWidth("modified")}>
                <div className="fs-7 limited-text" style={{ maxWidth: colWidth("modified") }}>
                    {toPrettyDate(props.job.modifiedAt)}
                </div>
                {
                    !layout.part("modified", "by") ? <></> :
                    props.job.lastUpdateUser ?
                        <FlexRow className="jobs-row-sub" title={`Modified by: ${props.job.lastUpdateUser?.fullName}`}>
                            <Avatar avatarUrl={props.job.lastUpdateUser?.avatarUrl} fullName={props.job.lastUpdateUser?.fullName} width={16} />
                            <span className="limited-text fs-8 ms-1" style={{ maxWidth: colWidth("modified") - 22 }}>
                                {isDemo() ? "Agent " + props.job.lastUpdateUser?.fullName?.substring(0, 2).toUpperCase() : props.job.lastUpdateUser?.fullName}
                            </span>
                        </FlexRow>
                        : <FlexRow className="jobs-row-sub" title={`Created by: ${props.job.creatorUser?.fullName}`}>
                            <Avatar avatarUrl={props.job.creatorUser?.avatarUrl} fullName={props.job.creatorUser?.fullName} width={16} />
                            <span className="limited-text fs-8 ms-1" style={{ maxWidth: colWidth("modified") - 22 }}>
                                {isDemo() ? "Agent " + props.job.creatorUser?.fullName?.substring(0, 2).toUpperCase() : props.job.creatorUser?.fullName}
                            </span>
                        </FlexRow>
                }
            </div>
        ),
        created: (
            <div key="created" style={cellWidth("created")}>
                <div className="fs-7 limited-text" style={{ maxWidth: colWidth("created") }}>
                    {toPrettyDate(props.job.createdAt)}
                </div>
                {
                    props.job.creatorUser && layout.part("created", "by") &&
                    <FlexRow className="jobs-row-sub" title={`Created by: ${props.job.creatorUser.fullName}`}>
                        <Avatar avatarUrl={props.job.creatorUser.avatarUrl} fullName={props.job.creatorUser.fullName} width={16} />
                        <span className="limited-text fs-8 ms-1" style={{ maxWidth: colWidth("created") - 30 }}>
                            {isDemo() ? "Agent " + props.job.creatorUser.fullName?.substring(0, 2).toUpperCase() : props.job.creatorUser.fullName}
                        </span>
                    </FlexRow>
                }
            </div>
        ),
        statusChange: (
            <div key="statusChange" style={cellWidth("statusChange")}>
                <div className="fs-7 limited-text" style={{ maxWidth: colWidth("statusChange") }}>
                    {props.job.lastStatusUpdatedAt ? toPrettyDate(props.job.lastStatusUpdatedAt) : "-"}
                </div>
                {
                    props.job.lastStatusNote && layout.part("statusChange", "note") &&
                    <div className="fs-8 text-gray-700 limited-text jobs-row-sub" title={props.job.lastStatusNote} style={{ maxWidth: colWidth("statusChange") - 20 }}>
                        <Icon icon="note-sticky" type="solid" className="me-1" size={9} />
                        {props.job.lastStatusNote}
                    </div>
                }
                {
                    props.job.lastStatusUser && layout.part("statusChange", "by") &&
                    <FlexRow className="jobs-row-sub" title={`Changed by: ${props.job.lastStatusUser.fullName}`}>
                        <Avatar avatarUrl={props.job.lastStatusUser.avatarUrl} fullName={props.job.lastStatusUser.fullName} width={16} />
                        <span className="limited-text fs-8 ms-1" style={{ maxWidth: colWidth("statusChange") - 22 }}>
                            {isDemo() ? "Agent " + props.job.lastStatusUser.fullName?.substring(0, 2).toUpperCase() : props.job.lastStatusUser.fullName}
                        </span>
                    </FlexRow>
                }
            </div>
        ),
    }

    return (
        <div className={`bg-hover-secondary jobs-board-row${props.selectionMode ? " selection-mode" : ""}${props.selected ? " selected" : ""}${jobColor ? " job-colored" : ""}`}
            style={{
                borderBottom: "1px solid #ccc",
                // The left inset is the colour band's lane — it keeps the band clear of the
                // bulk-select checkbox. JobDataFullCardHead pads to the same value so the
                // columns stay aligned with their titles.
                padding: "2px 2px 2px 14px",
                // When the columns' minimums don't fit, the row widens and the board scrolls sideways.
                minWidth: layout.total + 14 + 24 + 2 + (layout.settings.density == "compact" ? COMPACT_ACTIONS_WIDTH : 0),
                backgroundColor: props.selected ? "var(--bs-light-primary)" : undefined,
                ...jobColorVars(jobColor)
            }}>

            {
                // Colourless rows keep their (empty) lane so it can be hovered and clicked to
                // paint the job; users who may not paint only ever see a static band.
                canPaint
                    ? <JobColorPicker job={props.job} variant="spine" />
                    : jobColor
                        ? <span className="color-selector-spine is-static" style={{ backgroundColor: jobColor }} />
                        : <></>
            }

            <FlexRow className="w-100 jobs-row-main">

                {
                    props.selectable &&
                    <div className="jobs-row-check" style={{ width: 24, minWidth: 24, flexShrink: 0 }}>
                        <input type="checkbox" className="jobs-check-input"
                            checked={!!props.selected}
                            onChange={() => props.onToggleSelect?.()} />
                    </div>
                }

                <div className="jobs-row-idcell" style={{
                    width: layout.idWidth,
                    minWidth: layout.idWidth,
                    maxWidth: layout.idWidth,
                    overflow: "hidden"
                }}>
                    <FlexRow className={`fs-7`} title={`Job ID: #${props.job.jobId}`}>
                        <a href="#" onClick={e => {
                            e.preventDefault();
                            if (props.onQuickView) props.onQuickView(props.job);
                        }}>
                            #{props.job.jobId}
                        </a>
                    </FlexRow>

                    {statusPicker}

                </div>

                {
                    // Each column is a fixed slot: its content plus a gap, nothing spills over.
                    listColumns.map(c => (
                        <div key={`cell-${c.id}`} className="jobs-row-cell" style={{
                            width: layout.width(c.id),
                            minWidth: layout.width(c.id),
                            maxWidth: layout.width(c.id),
                            paddingRight: LIST_COLUMN_GAP,
                            overflow: "hidden",
                            flexShrink: 0
                        }}>
                            {rowCells[c.id]}
                        </div>
                    ))
                }



            </FlexRow>


            <FlexRow visible={user?.userType != UserTypes.Technician} className="jobs-row-tags jobs-row-tagline" style={{ padding: "1px 4px 2px" }}>


                {tagBadges}

                <span className="jobs-row-addtag"><JobAddTag job={props.job} tags flags /></span>



                {/* Sticky to the board's right edge: when the columns overflow and the board
                    scrolls sideways, the actions stay in view and don't move with the scroll. */}
                <div className="ms-auto me-4 jobs-row-actions-pinned">

                    {actionIcons}

                </div>


            </FlexRow>


        </div>

    )
}


export default React.memo(JobDataFullCard)